import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { ExplorePageProps } from 'types/page'
import { ContentfulProducts } from 'parameters/products'
import { ROUTES } from 'parameters'
import { ProductConstraint } from 'services/ContentfulService/constraints'
import { CreditCards } from 'experiences/explore/CreditCards'

const CreditCardsPage: NextPage<PagePropsWrapper<ExplorePageProps>> = ({ metaTags, pageProps }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		{/* This code used to use the cnfEmbed query parameter to feature flag the isCnfEmbedExperience bool */}
		<CreditCards articles={pageProps.articles} isCnfEmbedExperience={true} />
	</StandardLayout>
)

CreditCardsPage.getInitialProps = explorePageInitialProps(
	ROUTES.CREDIT_CARDS,
	ProductConstraint(ContentfulProducts.CreditCards)
)

export default CreditCardsPage
